import React from "react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";

const RemoveInitialScheduleTermModal = ({
  itemId,
  dealerId,
  onDeleted,
  reference,
  deleteAction,
  ...props
}) => {
  return (
    <ModalBuilder
      submitAction={deleteAction}
      submitParams={{ itemId, dealerId }}
      onSubmitted={onDeleted}
      renderTrigger={(showModal) => (
        <div {...props} onClick={showModal} className="item">
          Delete
        </div>
      )}
      renderModal={(modalProps) => (
        <Modal.Confirmation {...modalProps} header={`Delete: ${reference}`}>
          {`${reference}: Delete Initial Schedule Term?`}
        </Modal.Confirmation>
      )}
    />
  );
};

export default RemoveInitialScheduleTermModal;
